import { Outlet, Navigate } from "react-router-dom";
import { useAuthStore } from "@/stores/authStore.ts";
import { Zap } from "lucide-react";
import { useTenant } from "@/stores/tenantStore.tsx";

export function AuthLayout() {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated());
  const { tenant, siteName } = useTenant();

  if (isAuthenticated) return <Navigate to="/dashboard" replace />;

  return (
    <div className="min-h-screen flex" style={{ backgroundColor: "#0a0a0a" }}>
      {/* Left panel — branding */}
      <div className="hidden lg:flex flex-col justify-between w-[480px] p-12"
        style={{ background: "linear-gradient(160deg, #1c1c1c 0%, #0a0a0a 100%)" }}>
        <div className="flex items-center gap-3">
          {tenant?.logoUrl ? (
            <img src={tenant.logoUrl} alt={siteName} className="w-10 h-10 rounded-xl object-contain" />
          ) : (
            <div className="w-10 h-10 rounded-xl flex items-center justify-center"
              style={{ backgroundColor: "#ff5b1f" }}>
              <Zap className="w-5 h-5 text-white" />
            </div>
          )}
          <span className="text-white font-semibold text-xl tracking-tight font-display">
            {siteName}
          </span>
        </div>

        <div>
          <h2 className="text-3xl font-semibold text-white leading-tight mb-4 font-display"
            style={{ letterSpacing: "-0.025em" }}>
            {tenant?.tagline || "Faceless YouTube videos, made in minutes."}
          </h2>
          <p className="text-[15px] leading-relaxed" style={{ color: "#6b6b6b" }}>
            Pick a topic, review the AI script, approve the storyboard, and
            download a publish-ready MP4. No editing skills required.
          </p>
        </div>

        <p className="text-xs" style={{ color: "#2e2e2e" }}>&copy; {new Date().getFullYear()} {siteName}</p>
      </div>

      {/* Right panel — form */}
      <div className="flex-1 flex items-center justify-center p-8" style={{ backgroundColor: "#faf8f3" }}>
        <div className="w-full max-w-[400px]">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
